import { yupResolver } from '@hookform/resolvers/yup'
import { FC, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'

interface propsType {
  toggleModal: () => void
  nysc: any
  setNysc: any
  onSave: (data: NyscUpdate) => Promise<void>
}

export type NyscUpdate = {
  hasCompletedNYSC: boolean
  certificateNumber: string
  placeOfPrimaryAssignment: string
  institutionAddress: string
}

const schema = yup.object().shape({
  hasCompletedNYSC: yup.boolean().oneOf([true], 'Field is required').required('Field is required'),
  certificateNumber: yup.string().required('Field is required'),
  placeOfPrimaryAssignment: yup.string().required('Field is required'),
  institutionAddress: yup.string().required('Field is required'),
})

const NyscUpdate: FC<propsType> = ({ toggleModal, nysc, setNysc, onSave }) => {
  const [request, setRequest] = useState(false)

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<NyscUpdate>({
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    if (nysc) {
      reset({
        hasCompletedNYSC: nysc.hasCompletedNYSC,
        certificateNumber: nysc.certificateNumber,
        placeOfPrimaryAssignment: nysc.placeOfPrimaryAssignment,
        institutionAddress: nysc.institutionAddress,
      })
    }
  }, [nysc, reset])

  const submitNewUserInformation = handleSubmit(async (data) => {
    setRequest(true)
    try {
      await onSave(data)

      toggleModal()
    } finally {
      setRequest(false)
    }
  })

  return (
    <div className='bank-update'>
      <form onSubmit={submitNewUserInformation}>
        <div className='form-group'>
          <label>NYSC Completed</label>
          <select
            className={`form-control custom-select ${errors.hasCompletedNYSC ? 'is-invalid' : ''}`}
            {...register('hasCompletedNYSC', {
              setValueAs: (value) => value === 'true',
            })}
          >
            <option value=''>Select</option>
            <option value='true'>Yes</option>
            <option value='false'>No</option>
          </select>
          {errors.hasCompletedNYSC && (
            <div className='invalid-feedback d-block'>{errors.hasCompletedNYSC.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <label>Certificate Number</label>
          <input
            type='text'
            className={`form-control ${errors.certificateNumber ? 'is-invalid' : ''}`}
            {...register('certificateNumber', {})}
          />
          {errors.certificateNumber && (
            <div className='invalid-feedback'>{errors.certificateNumber.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <label>Place of Primary Assignment (PPA)</label>
          <input
            type='text'
            className={`form-control ${errors.placeOfPrimaryAssignment ? 'is-invalid' : ''}`}
            {...register('placeOfPrimaryAssignment', {})}
          />
          {errors.placeOfPrimaryAssignment && (
            <div className='invalid-feedback'>{errors.placeOfPrimaryAssignment.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <label>Institution Address</label>
          <input
            type='text'
            className={`form-control ${errors.institutionAddress ? 'is-invalid' : ''}`}
            {...register('institutionAddress', {})}
          />
          {errors.institutionAddress && (
            <div className='invalid-feedback'>{errors.institutionAddress.message}</div>
          )}
        </div>

        <div className='form-group mt-4'>
          <button disabled={request} className='btn btn-default-2 w-100' type='submit'>
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default NyscUpdate